import React from 'react';
import { Building, Wrench, Tractor } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './DossierBuildingsMeans.css';

const getIcon = (type) => {
  if (type === 'building' || type.toLowerCase().includes('warehouse') || type.toLowerCase().includes('office') || type.toLowerCase().includes('greenhouse')) {
    return Building;
  }
  if (type.toLowerCase().includes('tractor') || type.toLowerCase().includes('harvester') || type.toLowerCase().includes('seeder')) {
    return Tractor;
  }
  return Wrench;
};

export function DossierBuildingsMeans({ buildings = [], means = [] }) {
  const { t } = useTranslation();
  const allItems = [
    ...(buildings || []).map(item => ({ ...item, itemType: 'building' })),
    ...(means || []).map(item => ({ ...item, itemType: 'equipment' })),
  ];

  if (allItems.length === 0) {
    return null;
  }

  return (
    <div className="dossier-buildings-means">
      <h4 className="dossier-buildings-means__title">{t('reports.workspace.dossier.sections.buildingsMeans.title')}</h4>
      
      <div className="dossier-buildings-means__list">
        {allItems.map((item) => {
          const Icon = getIcon(item.type || item.itemType);
          return (
            <div key={item.id} className="dossier-buildings-means__item">
              <Icon size={16} className="dossier-buildings-means__icon" />
              <span className="dossier-buildings-means__text">{item.type || item.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
